module.exports = __webpack_public_path__ + "f7d7fb40440c49709cb113129d67568c.png";